import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionIdService {
  private sessionId: string | null = null;

  constructor() {
    this.initializeSessionId();
  }

  private generateSessionId(): string {
    const timestamp = Date.now();
    const randomString = Math.random().toString(36).substring(2, 15) + 
                        Math.random().toString(36).substring(2, 15);
    return `${timestamp}-${randomString}`;
  }

  private initializeSessionId(): void {
    const storedSessionId = sessionStorage.getItem('app_session_id');
    
    if (storedSessionId) {
      this.sessionId = storedSessionId;
    } else {
      this.sessionId = this.generateSessionId();
      sessionStorage.setItem('app_session_id', this.sessionId);
    }
  }

  getSessionId(): string {
    if (!this.sessionId) {
      this.initializeSessionId();
    }
    return this.sessionId || '';
  }

  resetSessionId(): void {
    this.sessionId = this.generateSessionId();
    sessionStorage.setItem('app_session_id', this.sessionId);
  }
}

